/**
 * Strict parser for the redesigned deposit flow.
 *
 * Returns the parsed positive number (integer or decimal) when valid, or null
 * when the value is empty, malformed, negative or zero. Range (min/max) checks
 * are intentionally left to the caller so they can surface the correct
 * minimum/maximum warning on submit.
 */
export function parseRedesignDepositAmount(amount, env) {
	if (amount === null || amount === "" || amount === undefined) return null;

	const rawAmount = String(amount);
	if (
		rawAmount.includes("e") ||
		rawAmount.includes("E") ||
		rawAmount.includes("+") ||
		rawAmount.includes("-")
	) return null;

	const parsedAmount = Number(rawAmount);
	if (!Number.isFinite(parsedAmount) || parsedAmount <= 0) return null;

	return parsedAmount;
}

/**
 * Legacy parser for the pre-redesign deposit flow.
 *
 * Mirrors historical legacy behaviour as closely as possible by coercing the
 * value with Number() and only requiring that the result is finite and > 0.
 * Range warnings remain a submit-time concern in the legacy path.
 */
export function parseLegacyDepositAmount(amount) {
	if (amount === null || amount === "" || amount === undefined) return null;

	const parsedAmount = Number(amount);
	if (!Number.isFinite(parsedAmount)) return null;
	if (parsedAmount <= 0) return null;

	return parsedAmount;
}
